/**
 * Professional Details Section for Assistant Profile
 * Handles insurance and transportation
 */
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Shield, Car } from "lucide-react";

export default function ProfessionalDetailsSection({
  hasInsurance,
  setHasInsurance,
  insuranceCoverage,
  setInsuranceCoverage,
  hasTransportation,
  setHasTransportation,
}) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Professional Details</h2>
      
      <div className="space-y-6">
        {/* Insurance */}
        <div className="p-4 bg-white/[0.05] border border-white/10 rounded-sm">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="font-medium flex items-center gap-2">
                <Shield className="w-4 h-4" />
                Liability Insurance
              </div>
              <div className="text-white/50 text-sm">Do you carry professional liability insurance?</div>
            </div>
            <Switch 
              checked={hasInsurance} 
              onCheckedChange={setHasInsurance}
              data-testid="insurance-switch"
            />
          </div>
          {hasInsurance && (
            <div>
              <Label className="text-sm text-white/60">Coverage Amount</Label>
              <Input
                value={insuranceCoverage}
                onChange={(e) => setInsuranceCoverage(e.target.value)}
                placeholder="e.g., $1M/$2M"
                className="mt-2 bg-[#0a0a0a] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
                data-testid="insurance-coverage-input"
              />
            </div>
          )}
        </div>

        {/* Transportation */}
        <div className="flex items-center justify-between p-4 bg-white/[0.05] border border-white/10 rounded-sm">
          <div>
            <div className="font-medium flex items-center gap-2">
              <Car className="w-4 h-4" />
              Own Transportation
            </div>
            <div className="text-white/50 text-sm">Can you get to locations on your own?</div>
          </div>
          <Switch 
            checked={hasTransportation} 
            onCheckedChange={setHasTransportation}
            data-testid="transportation-switch"
          />
        </div>
      </div>
    </Card>
  );
}
